import {WlDropdown} from "../../webcomponents/dropdown/dropdown.component";
import {WlIntegerInput} from "../../webcomponents/integerInput/integerInput.component";

export type InputOrTextOrSelect = HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement | WlDropdown;
export type InputOrTextOrSelectOrIntegerInput = InputOrTextOrSelect | WlIntegerInput;

export class ErrorVisibilityManager {
    static manageErrorVisibility(element: InputOrTextOrSelectOrIntegerInput, isValid: boolean) {
        if (isValid) {
            this.hideFieldError(element)
            return true
        } else {
            this.showFieldError(element);
            return false
        }
    }

    static showFieldError(element: InputOrTextOrSelectOrIntegerInput) {
        this.showInputError(element);
        this.showDefaultDivError(element);
    }

    static hideFieldError(element: InputOrTextOrSelectOrIntegerInput) {
        this.hideInputError(element);
        this.hideDefaultDivError(element);
    }

    static showDefaultDivError(element: InputOrTextOrSelectOrIntegerInput) {
        this.getDefaultErrorMessageElement(element)?.classList.add('active');
    }

    static hideDefaultDivError(element: InputOrTextOrSelectOrIntegerInput) {
        this.getDefaultErrorMessageElement(element)?.classList.remove('active');
    }

    static getInputContainer(element: InputOrTextOrSelectOrIntegerInput) {
        return element.closest('.adform-input-wrapper')
    }

    static showInputError(element: InputOrTextOrSelectOrIntegerInput) {
        element.classList.add('invalid');
    }

    static hideInputError(element: InputOrTextOrSelectOrIntegerInput) {
        element.classList.remove('invalid');
    }

    private static getDefaultErrorMessageElement(element: InputOrTextOrSelectOrIntegerInput) {
        return this.getInputContainer(element)?.querySelector('.error-text')
    }
}
